import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Home from "./pages/Home";
import Adn from "./pages/Adn";
import Audiencias from "./pages/Audiencias";
import HamburgerMenu from "./components/HamburgerMenu";
import 'bootstrap/dist/css/bootstrap.min.css';
import MetaSistema from "./pages/MetaSistema";
import SolucionesPublicitarias from "./pages/SolucionesPublicitarias";
import RateCard from "./pages/RateCard";
import ScrollToTop from "./components/ScrollToTop";

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,  
      once: false,  
      mirror: false,  
      threshold: 0.2  
    });
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <HamburgerMenu />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/adn" element={<Adn />} />
          <Route path="/audiencias" element={<Audiencias />} />
          <Route path="/metasistema" element={<MetaSistema />} />
          <Route path="/solucionespublicitarias" element={<SolucionesPublicitarias />} />
          <Route path="/ratecard" element={<RateCard />} />
        </Routes>
      </main>
    </Router>
  );
};

export default App;

